module.exports = fox._r("fonts/museosanscyrl_0-webfont.woff", __webpack_public_path__ + "fonts/3T4-GYO.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_0-webfont.woff
// module id = 578
// module chunks = 2